<template>
  <div class="autocomplete">
    <md-field>
      <label>{{placeholder}}</label>
      <md-input
        @input="onChange"
        v-model="search"
        @keydown.native.down="onArrowDown"
        @keydown.native.up="onArrowUp"
        @keydown.native.enter="onEnter"
        @click="onClick"
      ></md-input>
    </md-field>
    <md-list class="autocomplete-results md-elevation-6" v-show="isOpen && items.length > 0">
      <md-list-item v-if="isLoading">
        <span class="md-list-item-text">Loading results...</span>
      </md-list-item>
      <md-list-item
        v-else
        v-for="(item, i) in items"
        :key="i"
        @click="setResult(item)"
        class="autocomplete-result"
        :class="{ 'is-active': i === arrowCounter }"
      >
        <slot name="autocomplete-item" :row="item">
          {{item}}
        </slot>
      </md-list-item>
    </md-list>
  </div>
</template>

<script>
export default {
  name: "autocomplete-async",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Buscar..."
    },
    items: {
      type: Array,
      required: false,
      default: () => []
    },
  },

  data() {
    return {
      isOpen: false,
      search: "",
      selected: null,
      isLoading: false,
      arrowCounter: 0
    };
  },

  methods: {
    onChange() {
      this.$emit("changed", this.search);
      this.isLoading = true;
    },
    setResult(result) {
      this.search = "";
      this.selected = result;
      this.isOpen = false;
      this.$emit("selected", this.selected);
    },
    onArrowDown(evt) {
      if (!this.isOpen) {
        this.isOpen = true;
      } else {
        if (this.arrowCounter < this.items.length - 1) {
          this.arrowCounter = this.arrowCounter + 1;
        }
      }
    },
    onClick() {
      if (!this.isOpen) {
        this.isOpen = true;
      }
    },
    onArrowUp() {
      if (!this.isOpen) {
        this.isOpen = true;
      } else {
        if (this.arrowCounter > 0) {
          this.arrowCounter = this.arrowCounter - 1;
        }
      }
    },
    onEnter() {
      this.search = "";
      this.selected = this.items[this.arrowCounter];
      this.isOpen = false;
      this.arrowCounter = -1;
      this.$emit("selected", this.selected);
    },
    handleClickOutside(evt) {
      if (!this.$el.contains(evt.target)) {
        this.isOpen = false;
        this.arrowCounter = -1;
      }
    }
  },
  watch: {
    items: function(val, oldValue) {
      this.isLoading = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    document.removeEventListener("click", this.handleClickOutside);
  }
};
</script>



<style lang="scss" scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  position: absolute;
  background-color: white;
  z-index: 1000;
  width: 100%;
  max-height: 600px;
  overflow-y: auto;
}

.autocomplete-result {
  font-size: 10px;
}
.md-list-item {
  margin-right: 5px;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>
